/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddFamilyParentDTO,
  AdminFamilyDetailDTO,
  AdminFamilyListItemDTOQueryResultDTO,
  AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams,
  AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams,
  FeesAndTuitionDTO,
  FilterModelDTO,
  QueryColumnConfigDTO,
  UpdateVenmoPreferenceDTO,
  UpsertAdminFamilyDTO,
  UpsertChildDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminOrganizationFamilyGetAdminFamiliesForOrganization = (
    organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminFamilyListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryKey = (organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationFamily`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>> = ({ signal }) => adminOrganizationFamilyGetAdminFamiliesForOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>>
export type AdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryError = ErrorType<unknown>


export function useAdminOrganizationFamilyGetAdminFamiliesForOrganization<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamiliesForOrganization<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamiliesForOrganization<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationFamilyGetAdminFamiliesForOrganization<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationFamilyGetAdminFamiliesForOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationFamilyGetAdminFamiliesForOrganizationList = (
    organizationId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminFamilyListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminOrganizationFamilyGetAdminFamiliesForOrganizationListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyGetAdminFamiliesForOrganizationList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>, {organizationId: number;data: FilterModelDTO[];params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams}> = (props) => {
          const {organizationId,data,params} = props ?? {};

          return  adminOrganizationFamilyGetAdminFamiliesForOrganizationList(organizationId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyGetAdminFamiliesForOrganizationListMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>>
    export type AdminOrganizationFamilyGetAdminFamiliesForOrganizationListMutationBody = FilterModelDTO[]
    export type AdminOrganizationFamilyGetAdminFamiliesForOrganizationListMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyGetAdminFamiliesForOrganizationList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>, TError,{organizationId: number;data: FilterModelDTO[];params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamiliesForOrganizationList>>,
        TError,
        {organizationId: number;data: FilterModelDTO[];params?: AdminOrganizationFamilyGetAdminFamiliesForOrganizationListParams},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyGetAdminFamiliesForOrganizationListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyGetAdminFamilyFilterConfig = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationFamilyGetAdminFamilyFilterConfigQueryKey = (organizationId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationFamily/filter-config`] as const;
    }

    
export const getAdminOrganizationFamilyGetAdminFamilyFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationFamilyGetAdminFamilyFilterConfigQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>> = ({ signal }) => adminOrganizationFamilyGetAdminFamilyFilterConfig(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationFamilyGetAdminFamilyFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>>
export type AdminOrganizationFamilyGetAdminFamilyFilterConfigQueryError = ErrorType<unknown>


export function useAdminOrganizationFamilyGetAdminFamilyFilterConfig<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamilyFilterConfig<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamilyFilterConfig<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationFamilyGetAdminFamilyFilterConfig<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationFamilyGetAdminFamilyFilterConfigQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationFamilyGetAdminFamilyDetail = (
    organizationId: number,
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminFamilyDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationFamilyGetAdminFamilyDetailQueryKey = (organizationId: number,
    id: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${id}`] as const;
    }

    
export const getAdminOrganizationFamilyGetAdminFamilyDetailQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError = ErrorType<unknown>>(organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationFamilyGetAdminFamilyDetailQueryKey(organizationId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>> = ({ signal }) => adminOrganizationFamilyGetAdminFamilyDetail(organizationId,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationFamilyGetAdminFamilyDetailQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>>
export type AdminOrganizationFamilyGetAdminFamilyDetailQueryError = ErrorType<unknown>


export function useAdminOrganizationFamilyGetAdminFamilyDetail<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamilyDetail<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetAdminFamilyDetail<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationFamilyGetAdminFamilyDetail<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError = ErrorType<unknown>>(
 organizationId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetAdminFamilyDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationFamilyGetAdminFamilyDetailQueryOptions(organizationId,id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationFamilyUpdateFamilyForOrganization = (
    organizationId: number,
    id: number,
    upsertAdminFamilyDTO: UpsertAdminFamilyDTO,
 ) => {
      
      
      return customInstance<AdminFamilyDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminFamilyDTO
    },
      );
    }
  


export const getAdminOrganizationFamilyUpdateFamilyForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminFamilyDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminFamilyDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyUpdateFamilyForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>, {organizationId: number;id: number;data: UpsertAdminFamilyDTO}> = (props) => {
          const {organizationId,id,data} = props ?? {};

          return  adminOrganizationFamilyUpdateFamilyForOrganization(organizationId,id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyUpdateFamilyForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>>
    export type AdminOrganizationFamilyUpdateFamilyForOrganizationMutationBody = UpsertAdminFamilyDTO
    export type AdminOrganizationFamilyUpdateFamilyForOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyUpdateFamilyForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>, TError,{organizationId: number;id: number;data: UpsertAdminFamilyDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyUpdateFamilyForOrganization>>,
        TError,
        {organizationId: number;id: number;data: UpsertAdminFamilyDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyUpdateFamilyForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyDeleteFamilyForOrganization = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminOrganizationFamilyDeleteFamilyForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyDeleteFamilyForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminOrganizationFamilyDeleteFamilyForOrganization(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyDeleteFamilyForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>>
    
    export type AdminOrganizationFamilyDeleteFamilyForOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyDeleteFamilyForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyDeleteFamilyForOrganization>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyDeleteFamilyForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyAddFamilyToOrganization = (
    organizationId: number,
    familyId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/add/${familyId}`, method: 'POST', signal
    },
      );
    }
  


export const getAdminOrganizationFamilyAddFamilyToOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>, TError,{organizationId: number;familyId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>, TError,{organizationId: number;familyId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyAddFamilyToOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>, {organizationId: number;familyId: number}> = (props) => {
          const {organizationId,familyId} = props ?? {};

          return  adminOrganizationFamilyAddFamilyToOrganization(organizationId,familyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyAddFamilyToOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>>
    
    export type AdminOrganizationFamilyAddFamilyToOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyAddFamilyToOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>, TError,{organizationId: number;familyId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyAddFamilyToOrganization>>,
        TError,
        {organizationId: number;familyId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyAddFamilyToOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyReactivateFamilyForOrganization = (
    organizationId: number,
    id: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${id}/reactivate`, method: 'PUT'
    },
      );
    }
  


export const getAdminOrganizationFamilyReactivateFamilyForOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyReactivateFamilyForOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>, {organizationId: number;id: number}> = (props) => {
          const {organizationId,id} = props ?? {};

          return  adminOrganizationFamilyReactivateFamilyForOrganization(organizationId,id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyReactivateFamilyForOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>>
    
    export type AdminOrganizationFamilyReactivateFamilyForOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyReactivateFamilyForOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>, TError,{organizationId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyReactivateFamilyForOrganization>>,
        TError,
        {organizationId: number;id: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyReactivateFamilyForOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyAddChildToFamily = (
    organizationId: number,
    organizationFamilyId: number,
    upsertChildDTO: UpsertChildDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/create-child/${organizationFamilyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertChildDTO, signal
    },
      );
    }
  


export const getAdminOrganizationFamilyAddChildToFamilyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: UpsertChildDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: UpsertChildDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyAddChildToFamily'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>, {organizationId: number;organizationFamilyId: number;data: UpsertChildDTO}> = (props) => {
          const {organizationId,organizationFamilyId,data} = props ?? {};

          return  adminOrganizationFamilyAddChildToFamily(organizationId,organizationFamilyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyAddChildToFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>>
    export type AdminOrganizationFamilyAddChildToFamilyMutationBody = UpsertChildDTO
    export type AdminOrganizationFamilyAddChildToFamilyMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyAddChildToFamily = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: UpsertChildDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToFamily>>,
        TError,
        {organizationId: number;organizationFamilyId: number;data: UpsertChildDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyAddChildToFamilyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyAddChildToOrganization = (
    organizationId: number,
    childId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/add-child/${childId}`, method: 'PUT'
    },
      );
    }
  


export const getAdminOrganizationFamilyAddChildToOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>, TError,{organizationId: number;childId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>, TError,{organizationId: number;childId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyAddChildToOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>, {organizationId: number;childId: number}> = (props) => {
          const {organizationId,childId} = props ?? {};

          return  adminOrganizationFamilyAddChildToOrganization(organizationId,childId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyAddChildToOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>>
    
    export type AdminOrganizationFamilyAddChildToOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyAddChildToOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>, TError,{organizationId: number;childId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyAddChildToOrganization>>,
        TError,
        {organizationId: number;childId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyAddChildToOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyUpdateChild = (
    organizationId: number,
    childId: number,
    upsertChildDTO: UpsertChildDTO,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/update-child/${childId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertChildDTO
    },
      );
    }
  


export const getAdminOrganizationFamilyUpdateChildMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>, TError,{organizationId: number;childId: number;data: UpsertChildDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>, TError,{organizationId: number;childId: number;data: UpsertChildDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyUpdateChild'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>, {organizationId: number;childId: number;data: UpsertChildDTO}> = (props) => {
          const {organizationId,childId,data} = props ?? {};

          return  adminOrganizationFamilyUpdateChild(organizationId,childId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyUpdateChildMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>>
    export type AdminOrganizationFamilyUpdateChildMutationBody = UpsertChildDTO
    export type AdminOrganizationFamilyUpdateChildMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyUpdateChild = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>, TError,{organizationId: number;childId: number;data: UpsertChildDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyUpdateChild>>,
        TError,
        {organizationId: number;childId: number;data: UpsertChildDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyUpdateChildMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyDeleteChildFromFamily = (
    organizationId: number,
    childId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/delete-child/${childId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminOrganizationFamilyDeleteChildFromFamilyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>, TError,{organizationId: number;childId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>, TError,{organizationId: number;childId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyDeleteChildFromFamily'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>, {organizationId: number;childId: number}> = (props) => {
          const {organizationId,childId} = props ?? {};

          return  adminOrganizationFamilyDeleteChildFromFamily(organizationId,childId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyDeleteChildFromFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>>
    
    export type AdminOrganizationFamilyDeleteChildFromFamilyMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyDeleteChildFromFamily = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>, TError,{organizationId: number;childId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyDeleteChildFromFamily>>,
        TError,
        {organizationId: number;childId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyDeleteChildFromFamilyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyDeleteStudentFromOrganization = (
    organizationId: number,
    studentId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/delete-student/${studentId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminOrganizationFamilyDeleteStudentFromOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>, TError,{organizationId: number;studentId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>, TError,{organizationId: number;studentId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyDeleteStudentFromOrganization'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>, {organizationId: number;studentId: number}> = (props) => {
          const {organizationId,studentId} = props ?? {};

          return  adminOrganizationFamilyDeleteStudentFromOrganization(organizationId,studentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyDeleteStudentFromOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>>
    
    export type AdminOrganizationFamilyDeleteStudentFromOrganizationMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyDeleteStudentFromOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>, TError,{organizationId: number;studentId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyDeleteStudentFromOrganization>>,
        TError,
        {organizationId: number;studentId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyDeleteStudentFromOrganizationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyGetTuitionAndFeesForFamily = (
    organizationId: number,
    organizationFamlyId: number,
    semesterId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FeesAndTuitionDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/tuition-and-fees/${organizationFamlyId}/${semesterId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryKey = (organizationId: number,
    organizationFamlyId: number,
    semesterId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminOrganizationFamily/tuition-and-fees/${organizationFamlyId}/${semesterId}`] as const;
    }

    
export const getAdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryOptions = <TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError = ErrorType<unknown>>(organizationId: number,
    organizationFamlyId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryKey(organizationId,organizationFamlyId,semesterId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>> = ({ signal }) => adminOrganizationFamilyGetTuitionAndFeesForFamily(organizationId,organizationFamlyId,semesterId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && organizationFamlyId && semesterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>>
export type AdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryError = ErrorType<unknown>


export function useAdminOrganizationFamilyGetTuitionAndFeesForFamily<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationFamlyId: number,
    semesterId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetTuitionAndFeesForFamily<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationFamlyId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>,
          TError,
          Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminOrganizationFamilyGetTuitionAndFeesForFamily<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationFamlyId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminOrganizationFamilyGetTuitionAndFeesForFamily<TData = Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError = ErrorType<unknown>>(
 organizationId: number,
    organizationFamlyId: number,
    semesterId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminOrganizationFamilyGetTuitionAndFeesForFamily>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminOrganizationFamilyGetTuitionAndFeesForFamilyQueryOptions(organizationId,organizationFamlyId,semesterId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminOrganizationFamilyUpdateVenmoPreferenceForFamily = (
    organizationId: number,
    organizationFamilyId: number,
    semesterId: number,
    updateVenmoPreferenceDTO: UpdateVenmoPreferenceDTO,
 ) => {
      
      
      return customInstance<FeesAndTuitionDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/tuition-and-fees/${organizationFamilyId}/${semesterId}/venmo-preference`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateVenmoPreferenceDTO
    },
      );
    }
  


export const getAdminOrganizationFamilyUpdateVenmoPreferenceForFamilyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>, TError,{organizationId: number;organizationFamilyId: number;semesterId: number;data: UpdateVenmoPreferenceDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>, TError,{organizationId: number;organizationFamilyId: number;semesterId: number;data: UpdateVenmoPreferenceDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyUpdateVenmoPreferenceForFamily'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>, {organizationId: number;organizationFamilyId: number;semesterId: number;data: UpdateVenmoPreferenceDTO}> = (props) => {
          const {organizationId,organizationFamilyId,semesterId,data} = props ?? {};

          return  adminOrganizationFamilyUpdateVenmoPreferenceForFamily(organizationId,organizationFamilyId,semesterId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyUpdateVenmoPreferenceForFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>>
    export type AdminOrganizationFamilyUpdateVenmoPreferenceForFamilyMutationBody = UpdateVenmoPreferenceDTO
    export type AdminOrganizationFamilyUpdateVenmoPreferenceForFamilyMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyUpdateVenmoPreferenceForFamily = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>, TError,{organizationId: number;organizationFamilyId: number;semesterId: number;data: UpdateVenmoPreferenceDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyUpdateVenmoPreferenceForFamily>>,
        TError,
        {organizationId: number;organizationFamilyId: number;semesterId: number;data: UpdateVenmoPreferenceDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyUpdateVenmoPreferenceForFamilyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyAddParentToFamily = (
    organizationId: number,
    organizationFamilyId: number,
    addFamilyParentDTO: AddFamilyParentDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${organizationFamilyId}/parents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addFamilyParentDTO, signal
    },
      );
    }
  


export const getAdminOrganizationFamilyAddParentToFamilyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: AddFamilyParentDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: AddFamilyParentDTO}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyAddParentToFamily'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>, {organizationId: number;organizationFamilyId: number;data: AddFamilyParentDTO}> = (props) => {
          const {organizationId,organizationFamilyId,data} = props ?? {};

          return  adminOrganizationFamilyAddParentToFamily(organizationId,organizationFamilyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyAddParentToFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>>
    export type AdminOrganizationFamilyAddParentToFamilyMutationBody = AddFamilyParentDTO
    export type AdminOrganizationFamilyAddParentToFamilyMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyAddParentToFamily = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>, TError,{organizationId: number;organizationFamilyId: number;data: AddFamilyParentDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyAddParentToFamily>>,
        TError,
        {organizationId: number;organizationFamilyId: number;data: AddFamilyParentDTO},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyAddParentToFamilyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminOrganizationFamilyRemoveParentFromFamily = (
    organizationId: number,
    organizationFamilyId: number,
    parentId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminOrganizationFamily/${organizationFamilyId}/parents/${parentId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminOrganizationFamilyRemoveParentFromFamilyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>, TError,{organizationId: number;organizationFamilyId: number;parentId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>, TError,{organizationId: number;organizationFamilyId: number;parentId: number}, TContext> => {
    
const mutationKey = ['adminOrganizationFamilyRemoveParentFromFamily'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>, {organizationId: number;organizationFamilyId: number;parentId: number}> = (props) => {
          const {organizationId,organizationFamilyId,parentId} = props ?? {};

          return  adminOrganizationFamilyRemoveParentFromFamily(organizationId,organizationFamilyId,parentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminOrganizationFamilyRemoveParentFromFamilyMutationResult = NonNullable<Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>>
    
    export type AdminOrganizationFamilyRemoveParentFromFamilyMutationError = ErrorType<unknown>

    export const useAdminOrganizationFamilyRemoveParentFromFamily = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>, TError,{organizationId: number;organizationFamilyId: number;parentId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminOrganizationFamilyRemoveParentFromFamily>>,
        TError,
        {organizationId: number;organizationFamilyId: number;parentId: number},
        TContext
      > => {

      const mutationOptions = getAdminOrganizationFamilyRemoveParentFromFamilyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    